module.exports = "<div id=\"compareTable{{widgetId}}\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/table-chart/table-chart.component.html
// module id = ../../../../../src/app/shared/components/graphs/table-chart/table-chart.component.html
// module chunks = main